import React from "react";
import ModalBasic from "../../../pages/component/ModalBasic";
import ValidationText from "../../../utils/validation/ValidationText";
import DropdownSelect from "../../dropdown/Dropdown";
import TextInput from "../../UIComponent/TextInput";
import ImageCropperWithUpload from "../../ImageUpload/UploadImage";

const AddExcoModal = (props) => {
  return (
    <ModalBasic
      id="add-exco-member-modal"
      modalOpen={props.setEXCOMemberModal}
      setModalOpen={props.setOpenModal}
      title="Add EXCO Member"
    >
      <div className="px-14 py-4">
        {/* <div className="grid grid-cols-2 gap-12 border-b-[1px] border-zinc-300 pb-10">
                    <div className="">
                        <h2 className="text-xl mb-1">Email Address<span className='text-[#C00000]'>*</span></h2>
                        <TextInput
                            placeholder=""
                            type="text"
                            name="email"
                            value={props.excoMemberData.email}
                            handleChange={props.handleChange}
                            onBlur={props.validateField}
                            identity="email"
                        />
                        <ValidationText error={props.validState.error.email} />
                    </div>
                    <div className="2xl:pt-7 lg:pt-7">
                        <button className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white font-bold"
                            onClick={() => props.searchExcoMember()}
                        // >Search</button>
                    </div>
                </div> */}
        <div className="container mx-auto p-4">
          <div className="grid grid-cols-12 gap-6">
            {/* First Row */}
            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700">
                First Name<span className="text-[#C00000]">*</span>
              </label>
              <div className="input flex ">
                <div className="w-[20%]">
                  <DropdownSelect
                    drpIdentity={"salutationId"}
                    optionArray={props.mrMrs}
                    setFilterParameters={props.setFilterParameters}
                    value={props.excoMemberData.salutationId}
                  />
                  {/* <ValidationText error={props.validState.error.salutationId} /> */}
                </div>

                <div className="flex flex-col w-full">
                  <TextInput
                    placeholder=""
                    type="text"
                    name="firstName"
                    value={props.excoMemberData.firstName}
                    handleChange={props.handleChange}
                    onBlur={props.validateField}
                    identity="firstName"
                    disabled={false}
                  />
                  <ValidationText error={props.validState.error.firstName} />
                </div>
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700">
                Last Name
              </label>
              <div className="input">
                <TextInput
                  placeholder=""
                  type="text"
                  name="lastName"
                  value={props.excoMemberData.lastName}
                  handleChange={props.handleChange}
                  identity="lastName"
                  disabled={false}
                />
                <ValidationText error={props.validState.error.lastName} />
              </div>
            </div>

            {/* Second Row */}

            <>
              {/* <div className="col-span-12 xl:col-span-6">
                            <label className="block text-sm font-medium text-gray-700">Company<span className='text-[#C00000]'>*</span></label>
                            
                            <DropdownSelect
                            disabled={false}
                            drpIdentity={"CorporateID"}
                            optionArray={props.organisationList}
                            setFilterParameters={props.setFilterParameters}
                            value={props.excoMemberData.corporateMemberId}
                            />
                            
                            
                            </div> */}
              <div className="col-span-12 xl:col-span-6">
                <label className="block text-sm font-medium text-gray-700">
                  Company
                </label>

                <TextInput
                  placeholder=""
                  type="text"
                  name="companyName"
                  value={props.excoMemberData.companyName}
                  identity="companyName"
                  handleChange={props.handleChange}
                />

                {/* <ValidationText error={props.validState.error.companyName} /> */}
              </div>
            </>
            {/* :
                        <>
                        <div className="col-span-12 xl:col-span-6">
                        <label className="block text-sm font-medium text-gray-700">Company<span className='text-[#C00000]'>*</span></label>
                                <div className="input">
                                    <TextInput
                                        placeholder=""
                                        type="text"
                                        name="companyName"
                                        value={props.excoMemberData.companyName}
                                        //handleChange={props.handleChange}
                                        //onBlur={props.validateField}
                                        identity="companyName"
                                        disabled={false}
                                    />
                                </div>
                            </div>
                        </> */}

            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700">
                Position<span className="text-[#C00000]">*</span>
              </label>
              <TextInput
                placeholder=""
                type="text"
                name="excoPosition"
                value={props.excoMemberData.excoPosition}
                identity="excoPosition"
                handleChange={props.handleChange}
              />

              <ValidationText error={props.validState.error.excoPosition} />
            </div>

            {/* Third Row */}
            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700">
                LinkedIn
              </label>

              <TextInput
                placeholder=""
                type="text"
                name="linkedIn"
                value={props.excoMemberData.linkedIn}
                identity="BasicInformation"
                handleChange={props.handleChange}
              />
            </div>
            <div className="col-span-12 xl:col-span-6 flex gap-3 items-center">

            <div className="upload-pdf-btn px-3">
              <label
                className="block text-sm font-medium text-gray-700"
                htmlFor="upload"
              >
                PDF Upload
              </label>

              <img
                className="uplod-svg inline-flex w-5 h-5 fill-[#757575] ml-4"
                src="/pdf-upload.svg"
                alt=""
              ></img>
              <input
                className="sr-only"
                id="upload"
                type="file"
                // onBlur={() => props.validateField("report")}
                onChange={(event) => props.onFileChange(event)}
              />

            </div>
              {props.excoMemberData.pdfDisplayName !== "" ? (
                <div>
                  <div className="relative mt-5">
                    {props.excoMemberData.pdfDisplayName}
                    <span
                      className="absolute top-[-5px] right-[-18px] bg-red-700 h-4 w-4 rounded-full flex items-center justify-center cursor-pointer"
                      onClick={() => props.onFileCancel()}
                    >
                      <p className="text-white text-[10px]">&#10006;</p>
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="col-span-12 xl:col-span-6">
              <label className="block text-sm font-medium text-gray-700">
                Description
              </label>
              <textarea
                id="description"
                className="signup-text-area form-input rounded-none w-full shadow-red  text-lg"
                name="description"
                rows="3"
                value={props.excoMemberData.description}
                onChange={(event) =>
                  props.handleChange(event, "EngagementTracking")
                }
              ></textarea>
              {/* <ValidationText error={props.validState.error.description} /> */}
            </div>

            {/* Image Upload */}
            <div className="col-span-12">
              <div className="text-center">
                <div className="inline-block">
                  <ImageCropperWithUpload
                    key={props.excoMemberData.imageUrl}
                    height={150}
                    width={150}
                    isCheckValidation={true}
                    MaxFileSize={2097152}
                    MaxFileSizeMessage={"1MB"}
                    onSaveImage={props.saveMainImage}
                    imageIdentity="imageURL"
                    intitImage={props.excoMemberData.imageUrl}
                    aspactRatio={1 / 1}
                    uploadBtn={"Upload Image"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-6 gap-4 px-6 py-16">
          <button
            className="col-start-1 col-end-3  w-32 px-7 py-2 bg-zinc-500 text-lg text-white font-bold"
            onClick={(event) => props.onClose(event)}
          >
            Cancel
          </button>
          <button
            className="col-end-8 col-span-1  w-32 px-7 py-2 btn-sm btn-red text-lg text-white font-bold"
            onClick={() => props.saveButtonClick()}
          >
            Add
          </button>
        </div>
      </div>
    </ModalBasic>
  );
};
export default AddExcoModal;
